var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.card.labels),function(label,index){return _c('span',{key:index},[_c('b-badge',{staticClass:"label-badge"},[_vm._v(" "+_vm._s(label.name)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }